export const eduEncode = (value) => btoa(value);

export const eduDecode = (encodedValue) => atob(encodedValue);

export const extractEncodedParams = (encodedValue) => {
  // Check if the item is a valid number using `isNaN`
  let dstr = eduDecode(encodedValue);
  const paramArray = dstr.split("/").map((item) => {
    return isNaN(item) ? item : Number(item);
  });
  return paramArray;
};
